export const environment = {
    production: true,
    version: '2023.1',
    baseUrl: 'https://syntaxmigrator-staging.beinex.com/',
    cookieDomain:'https://syntaxmigrator-staging.beinex.com/',
    apiVersion: 'api/v1/',
    clientId: '7cf604e5-3afd-44c5-8c12-275234a55ae0'
  };